export default __webpack_public_path__ + "static/media/tshirt-banner.844e76be.jpg";